

export interface AvailableSlotsRendererProps {
    availableSlots: number
}

const AvailableSlotsRenderer = (slots: AvailableSlotsRendererProps) => {

    const maxSlots = 4;
    
    return (
      <div className="d-flex gap-2" title={`${slots.availableSlots} place${slots.availableSlots > 1 ? 's' : ''} disponible${slots.availableSlots > 1 ? 's' : ''}`} data-bs-toggle="tooltip" data-bs-title={`${slots.availableSlots} places disponibles`}>
          {[...Array(maxSlots)].map((_, index) => (
          <div
            key={index}
            className={`host_slot border border-secondary rounded-circle ratio ratio-1x1 w-25 ${index < maxSlots - slots.availableSlots ? "bg-secondary" : ""}`}
          ></div>
        ))}
      </div>
    );

  };

  export default AvailableSlotsRenderer;
